/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './styles/css/basic-info-company.css';
import { Button, Segment, Form, Input, Header, Progress, Dropdown, Checkbox, Grid } from 'semantic-ui-react';
import { Link, Redirect} from 'react-router-dom';
import API from "../utility/API";
import ProgressBar from "../components/progress-bar";

class BasicInfoCompany extends Component {
  constructor() {
    super();
    this.state = {
      toNextPage: false,
      progress: 22.2,
      businessName: '',
      businessAddress1: '',
      businessAddress2: '',
      city: '',
      businessType: '',
      state: '',
      zipcode: '',
      country: '',
      businessIncorporation: '',
      importerNumber: '',
    }
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value }, console.log(this.state))

  getCookieValue = (name) => {
    var b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }
  
  handleRadioChange = (e, { value }) => this.setState({ value }, console.log(this.state))

  handleSubmit = () => {
    const { businessName, businessAddress1, businessAddress2, businessType, city, state, zipcode, country, businessIncorporation, importerNumber} = this.state

    this.setState({ businessName, businessAddress1, businessAddress2, importerNumber, businessType, city, state, zipcode, country, businessIncorporation, importerNumber,},
      console.log(this.state))
    
    console.log("here is the token", this.getCookieValue("kxCustomerToken"));

    API.companyInfo(
      this.getCookieValue("kxCustomerToken"),
      this.props.sessionData.companyName,
      this.state.businessAddress1,
      this.state.businessAddress2,
      this.state.city,
      this.state.state,
      this.state.country,
      this.state.businessType,
      this.state.businessIncorporation,
      this.state.value,
      this.state.importerNumber
    ).then(response => {
      return response.json()
    }).then(responseData => {
      console.log(responseData);
    }).then(
      this.setState({ toNextPage: true })
    ).catch(err => console.log('ERROR:', err))

    // this.props.storeProgressData("basicInfoCompany", "item progress-green")
  }

  render() {
    const optionsState = [
      { key: 'AL', text: 'AL', value: 'AL' },
      { key: 'AK', text: 'AK', value: 'AK' },
      { key: 'AZ', text: 'AZ', value: 'AZ' },
      { key: 'CA', text: 'CA', value: 'CA' },
      { key: 'CO', text: 'CO', value: 'CO' },
      { key: 'CT', text: 'CT', value: 'CT' },
      { key: 'DE', text: 'DE', value: 'DE' },
      { key: 'GA', text: 'GA', value: 'GA' },
      { key: 'HI', text: 'HI', value: 'HI' },
      { key: 'IL', text: 'IL', value: 'IL' },
      { key: 'IN', text: 'IN', value: 'IN' },
      { key: 'IA', text: 'IA', value: 'IA' },
      { key: 'KS', text: 'KS', value: 'KS' },
      { key: 'KY', text: 'KY', value: 'KY' },
      { key: 'LA', text: 'LA', value: 'LA' },
      { key: 'ME', text: 'ME', value: 'ME' },
      { key: 'MD', text: 'MD', value: 'MD' },
      { key: 'MA', text: 'MA', value: 'MA' },
      { key: 'MI', text: 'MI', value: 'MI' },
      { key: 'MN', text: 'MN', value: 'MN' },
      { key: 'MS', text: 'MS', value: 'MS' },
      { key: 'MO', text: 'MO', value: 'MO' },
      { key: 'MT', text: 'MT', value: 'MT' },
      { key: 'NE', text: 'NE', value: 'NE' },
      { key: 'NV', text: 'NV', value: 'NV' },
      { key: 'NH', text: 'NH', value: 'NH' },
      { key: 'NJ', text: 'NJ', value: 'NJ' },
      { key: 'NM', text: 'NM', value: 'NM' },
      { key: 'NY', text: 'NY', value: 'NY' },
      { key: 'NC', text: 'NC', value: 'NC' },
      { key: 'ND', text: 'ND', value: 'ND' },
      { key: 'OH', text: 'OH', value: 'OH' },
      { key: 'OK', text: 'OK', value: 'OK' },
      { key: 'OR', text: 'OR', value: 'OR' },
      { key: 'PA', text: 'PA', value: 'PA' },
      { key: 'RI', text: 'RI', value: 'RI' },
      { key: 'SC', text: 'SC', value: 'SC' },
      { key: 'SD', text: 'SD', value: 'SD' },
      { key: 'TN', text: 'TN', value: 'TN' },
      { key: 'TX', text: 'TX', value: 'TX' },
      { key: 'VT', text: 'VT', value: 'VT' },
      { key: 'VA', text: 'VA', value: 'VA' },
      { key: 'WA', text: 'WA', value: 'WA' },
      { key: 'WV', text: 'WV', value: 'WV' },
      { key: 'WI', text: 'WI', value: 'WI' },
      { key: 'WY', text: 'WY', value: 'WY' },
    ]
    const optionsBusiness = [
      { key: 'BT', text: 'Business Type', value: 'BT' },
      { key: 'BT1', text: 'Business Type 1', value: 'BT1' },
    ]
    const optionsCountry = [
      { key: 'USA', text: 'United States', value: 'USA' },
      { key: 'KH', text: 'Canada', value: 'KH' },
    ]
    const { businessName, businessAddress1, businessAddress2, city, businessType, state, zipcode, country, businessIncorporation, importerNumber } = this.state

    if (this.state.toNextPage === true) {
      this.props.storeProgressData("basicInfoCompany", "piece progress-green")
			return <Redirect to='/accountInfo1' /> 
    }

    return (
      <div>
        <ProgressBar progressData={this.props.progressData}/>
        <div>
          <h2>Basic Information</h2>
          <Segment padded='very' className="basic-info-company-segment">
            <Form>
              <Header as='h1'>Company Information</Header>
              <Form.Field>
                <label className="basic-info-company-label">BUSINESS NAME</label>
                <Input placeholder='Full Business Name'
                  name="businessName"
                  value={this.props.sessionData.companyName}
                  className="basic-info-company-input"
                  onChange={this.handleChange.bind(this)}
                />
              </Form.Field>

              <Form.Field>
                <label className="power-of-attorney-label">BUSINESS ADDRESS</label>
                <Input
                  name="businessAddress1"
                  value={businessAddress1}
                  className="power-of-attorney-input"
                  placeholder='Address Line 1'
                  onChange={this.handleChange.bind(this)}
                />

                <Input
                  name="businessAddress2"
                  value={businessAddress2}
                  className="power-of-attorney-input"
                  placeholder='Address Line 2 (optional)'
                  onChange={this.handleChange.bind(this)}
                />

                <Form.Group className="poa1-form-group">
                  <Form.Input onChange={this.handleChange.bind(this)} name="city" value={city} placeholder='City' width={8} />
                  <Form.Dropdown scrolling onChange={this.handleChange.bind(this)} name="state" value={state} className="poa1-state-dropdown" placeholder='State' options={optionsState} search placeholder={optionsState[0].text} width={5} />
                  <Form.Input onChange={this.handleChange.bind(this)} name="zipcode" value={zipcode} placeholder='Zipcode' width={6} />
                </Form.Group>
                <Dropdown fluid selection scrolling onChange={this.handleChange.bind(this)} name="country" value={country} className='poa1-dropdown' options={optionsCountry} search placeholder={optionsCountry[0].text}
                />
              </Form.Field>
              <Form.Field>

                <label className="basic-info-company-label">BUSINESS TYPE</label>
                <Dropdown fluid selection scrolling onChange={this.handleChange.bind(this)}name="businessType" value={businessType} className='poa1-dropdown' options={optionsBusiness} search placeholder={optionsBusiness[0].text} />


                <label className="basic-info-company-label">BUSINESS INCORPORATION</label>
                <Dropdown fluid selection scrolling onChange={this.handleChange.bind(this)} name="businessIncorporation" value={businessIncorporation} className='poa1-dropdown' options={optionsCountry} search placeholder={optionsCountry[0].text}
                />

                    <Form.Group className="importNumber">

                        <label className="basic-info-company-label">IMPORTER NUMBER</label>

                        <Form.Group className="importNumberRadios">

                          <Form.Radio
                            label='IRS'
                            value='irs'
                            checked={this.state.value === 'irs'}
                            onChange={this.handleRadioChange}
                          />

                          <Form.Radio
                            radio
                            label='SSN'
                            value='ssn'
                            checked={this.state.value === 'ssn'}
                            onChange={this.handleRadioChange}
                          />

                          <Form.Radio
                            radio
                            label='CBP'
                            value='cbp'
                            checked={this.state.value === 'cbp'}
                            onChange={this.handleRadioChange}
                          />

                        </Form.Group>

                    </Form.Group>


                    <Input
                      placeholder='Importer Number'
                      fluid
                      className="basic-info-company-input"
                      name="importerNumber"
                      value={importerNumber}
                      onChange={this.handleChange.bind(this)}
                    />
                  {/* </Row> */}

                <br />
                <br />
              </Form.Field>

            </Form>
            <div className="basic-info-company-buttonRow">
              <Link to='/basicinfo'>
                <Button type='submit' className="cancelBasicInfo-company">CANCEL</Button>
              </Link>
              {/* <Link to='/accountInfo1'> */}
                <Button type='submit' className="saveBasicInfo-company" onClick={this.handleSubmit} color="twitter">Save & Next</Button>
              {/* </Link> */}
            </div>
          </Segment>
        </div>
      </div>
    );
  }
}

export default BasicInfoCompany;
